import React, { useState, useEffect } from 'react';
import { get, post } from '../Services/http';
import { translate } from '../Services/translation';

const CheckoutEnjoyClubCollapse = ({
  imageUrl,
  bonus,
  loginUrl,
  signedUpForEnjoy,
  onSignUpForEnjoy,
  enjoyClubDescription,
}) => {
  const [isMounted, setIsMounted] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [canJoinEnjoy, setCanJoinEnjoy] = useState(false);
  const [isInEnjoy, setIsInEnjoy] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [signUpForEnjoy, setSignUpForEnjoy] = useState(signedUpForEnjoy);

  async function SignUpForEnjoy() {
    if (canJoinEnjoy) {
      try {
        await post('/api/enjoyClub/signUp');
        location.reload();
      } catch (err) {
        console.error(err);
      }
    }
  }

  async function checkEnjoyStatus() {
    try {
      const response = await get('/api/enjoyClub/check');
      const data = await response.json();
      if (isMounted) {
        setIsInEnjoy(data);
        setCanJoinEnjoy(!data);
        setIsLoggedIn(true);
      }
    } catch (err) {
      if (isMounted) {
        setIsLoggedIn(false);
      }
    }
  }

  function checkSignUpForEnjoy(e) {
    onSignUpForEnjoy(!signUpForEnjoy);
    setSignUpForEnjoy(!signUpForEnjoy);
  }

  useEffect(() => {
    setIsMounted(true);
    checkEnjoyStatus();

    // Had to make this "hack" since the async call finishes after it has been unmounted, so it throws
    return () => setIsMounted(false);
  }, []);

  if (!isLoggedIn) {
    return (
      <div className="enjoy-club-wrapper">
        <div className="enjoy-club-collapse">
          <div className="bonus-logo-wrapper">
            <img
              className="bonus-logo enjoy-club-collapse-item"
              src={imageUrl}
              alt="bonus logo image"
            />
            <div className="bonus-header-text enjoy-club-collapse-item">
              {translate('checkout.bonus.canget').replace('{0}', bonus)}
            </div>
          </div>
          <div className="bonus-action-wrapper">
            <label htmlFor="signUpForEnjoy" className="custom-checkbox">
              <input
                id="signUpForEnjoy"
                onChange={checkSignUpForEnjoy}
                checked={signUpForEnjoy}
                type="checkbox"
              />
              <span className="custom-checkbox-label">
                {translate('checkout.bonus.signup')}
              </span>
            </label>
            <div
              className={`collapse-block__header ${
                isOpen ? 'collapse-block__header-open' : ''
              }`}
              onClick={(_) => setIsOpen(!isOpen)}
            >
              {translate('checkout.bonus.title')}
            </div>
          </div>
          <div className="bonus-action-wrapper">
            <a href={loginUrl}>{translate('checkout.bonus.signin')}</a>
          </div>
        </div>
        {enjoyClubDescription && (
          <div
            className={`collapse-block__content ${
              isOpen ? 'collapse-block__content-open' : ''
            }`}
            dangerouslySetInnerHTML={{
              __html: enjoyClubDescription.value,
            }}
          ></div>
        )}
      </div>
    );
  }

  if (isLoggedIn && !isInEnjoy) {
    return (
      <div className="enjoy-club-wrapper">
        <div className="enjoy-club-collapse">
          <div className="bonus-logo-wrapper">
            <img
              className="bonus-logo enjoy-club-collapse-item"
              src={imageUrl}
              alt="bonus logo image"
            />
            <div className="bonus-header-text enjoy-club-collapse-item">
              {translate('checkout.bonus.canget').replace('{0}', bonus)}
            </div>
          </div>
          <div className="bonus-action-wrapper">
            <button onClick={SignUpForEnjoy} className="button">
              {translate('checkout.bonus.signup')}
            </button>
            <div
              className={`collapse-block__header ${
                isOpen ? 'collapse-block__header-open' : ''
              }`}
              onClick={(_) => setIsOpen(!isOpen)}
            >
              {translate('checkout.bonus.title')}
            </div>
          </div>
        </div>
        {enjoyClubDescription && (
          <div
            className={`collapse-block__content ${
              isOpen ? 'collapse-block__content-open' : ''
            }`}
            dangerouslySetInnerHTML={{
              __html: enjoyClubDescription.value,
            }}
          ></div>
        )}
      </div>
    );
  }

  return null;
};

export default CheckoutEnjoyClubCollapse;
